export const globalVars = {
  store: {},
  persistor: null,
};
